import React from 'react';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import './NotFoundPage.css';
import {FaChevronLeft} from "react-icons/fa";

const NotFoundPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const handleGoBack = () => {
    if (location.key !== "default") {
      navigate(-1);
    } else {
      navigate('/');
    }
  };
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="construction-icon">
          🚧
        </div>
        <h1 className="not-found-title">
          Oops! Page Under Construction
        </h1>
        
        <div className="error-code">
          404
        </div>
        
        <p className="not-found-message">
          We're working hard to bring you something amazing! 
          The page you're looking for is currently under construction.
        </p>
        
        <div className="construction-details">
          <div className="construction-item">
            <span className="construction-emoji">⚡</span>
            <span>Building new features</span>
          </div>
          <div className="construction-item">
            <span className="construction-emoji">🎨</span>
            <span>Designing better experiences</span>
          </div>
          <div className="construction-item">
            <span className="construction-emoji">🔧</span>
            <span>Fine-tuning performance</span>
          </div>
        </div>
        
        <div className="not-found-actions">
          <Link to="/" className="btn btn-primary">
            🏠 Back to Home
          </Link>
          <Link onClick={handleGoBack} className="btn btn-secondary">
            <FaChevronLeft /> Back to Previous Page
          </Link>
          <Link to="/how-it-works" className="btn btn-secondary">
            📖 Learn More
          </Link>
        </div>

        <div className="progress-bar-container">
          <div className="progress-label">Construction Progress</div>
          <div className="progress-bar">
            <div className="progress-fill"></div>
          </div>
          <div className="progress-text">75% Complete</div>
        </div>
        
        <div className="contact-info">
          <p>Need help? We're here for you!</p>
          <div className="contact-links">
            <a href="mailto:support@yourplatform.com" className="contact-link">
              📧 Contact Support
            </a>
            <Link to="/terms-and-conditions" className="contact-link">
              📋 Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
      
      <div className="floating-elements">
        <div className="floating-element" style={{animationDelay: '0s'}}>🔨</div>
        <div className="floating-element" style={{animationDelay: '2s'}}>⚙️</div>
        <div className="floating-element" style={{animationDelay: '4s'}}>🏗️</div>
        <div className="floating-element" style={{animationDelay: '6s'}}>📐</div>
      </div>
    </div>
  );
};

export default NotFoundPage;